import type { Location } from 'modules/core/lib/navigation/types'

export const navigation = {
  path: 'discover',
  children: {
    autoOnboarding: {
      path: 'onboarding',
    },
    productUpdates: {
      path: 'news',
      children: {
        item: {
          path: ':slug',
        },
      },
    },
    marketplace: {
      path: 'marketplace',
      children: {
        item: {
          path: ':id',
          children: {
            settings: {
              path: 'settings',
            },
          },
        },
        not_enabled: {
          path: 'not-enabled',
        },
        forbidden_access: {
          path: 'forbidden-access',
        },
        marketplace: {
          path: '',
        },
      },
    },
    marketplaceModules: {
      path: 'modules',
      children: {
        item: {
          path: ':id',
        },
        promotion: {
          path: 'promotion',
        },
      },
    },
    updatesWithCEO: {
      path: 'updates-with-ceo',
    },
    launchesWithCEO: {
      path: 'launches-with-ceo',
    },
    oneLandingPage: {
      path: 'one-landing',
    },
    onePromoPage: {
      path: 'one-promo',
    },
    landing: {
      path: 'landing',
      children: {
        item: {
          path: ':id',
        },
      },
    },
  },
} as const satisfies Location
